import type { TextStyle } from '../types';

export type TextFieldFontFamily = TextStyle['fontFamily'];

export interface TextFieldFont {
  label: string;
  css: string;          // font-family für Editor + Server-HTML
  jspdf: string;        // Font-Name für jsPDF (built-in oder Registrierungsname)
  widthFactor: number;  // Heuristik: mittlere Zeichenbreite / fontSize (für fitTextToCell)
  hasBold: boolean;     // echter Fettschnitt verfügbar
  files?: { regular: string; bold?: string };  // TTF-Pfade unter /fonts/ (fehlt = jsPDF built-in)
}

export const TEXT_FIELD_FONTS: Record<TextFieldFontFamily, TextFieldFont> = {
  standard: {
    label: 'Standard', css: "'Nunito', Arial, Helvetica, sans-serif",
    jspdf: 'helvetica', widthFactor: 0.55, hasBold: true,
  },
  serif: {
    label: 'Serif', css: "Georgia, 'Times New Roman', serif",
    jspdf: 'times', widthFactor: 0.52, hasBold: true,
  },
  druckschrift: {
    label: 'Druckschrift (Andika)', css: "'Andika', Arial, sans-serif",
    jspdf: 'Andika', widthFactor: 0.60, hasBold: true,
    files: { regular: '/fonts/Andika-Regular.ttf', bold: '/fonts/Andika-Bold.ttf' },
  },
  abeezee: {
    label: 'ABeeZee (Leseanfänger)', css: "'ABeeZee', Arial, sans-serif",
    jspdf: 'ABeeZee', widthFactor: 0.55, hasBold: false,
    files: { regular: '/fonts/ABeeZee-Regular.ttf' },
  },
  comicneue: {
    label: 'Comic Neue', css: "'Comic Neue', Arial, sans-serif",
    jspdf: 'ComicNeue', widthFactor: 0.52, hasBold: true,
    files: { regular: '/fonts/ComicNeue-Regular.ttf', bold: '/fonts/ComicNeue-Bold.ttf' },
  },
  atkinson: {
    label: 'Atkinson (sehr gut lesbar)', css: "'Atkinson Hyperlegible', Arial, sans-serif",
    jspdf: 'AtkinsonHyperlegible', widthFactor: 0.55, hasBold: true,
    files: { regular: '/fonts/AtkinsonHyperlegible-Regular.ttf', bold: '/fonts/AtkinsonHyperlegible-Bold.ttf' },
  },
  patrickhand: {
    label: 'Patrick Hand (Handschrift)', css: "'Patrick Hand', cursive",
    jspdf: 'PatrickHand', widthFactor: 0.48, hasBold: false,
    files: { regular: '/fonts/PatrickHand-Regular.ttf' },
  },
  schoolbell: {
    label: 'Schoolbell (Tafel)', css: "'Schoolbell', cursive",
    jspdf: 'Schoolbell', widthFactor: 0.50, hasBold: false,
    files: { regular: '/fonts/Schoolbell-Regular.ttf' },
  },
  kalam: {
    label: 'Kalam (Handschrift)', css: "'Kalam', cursive",
    jspdf: 'Kalam', widthFactor: 0.55, hasBold: true,
    files: { regular: '/fonts/Kalam-Regular.ttf', bold: '/fonts/Kalam-Bold.ttf' },
  },
  amaticsc: {
    label: 'Amatic SC (Überschrift)', css: "'Amatic SC', cursive",
    jspdf: 'AmaticSC', widthFactor: 0.35, hasBold: true,
    files: { regular: '/fonts/AmaticSC-Regular.ttf', bold: '/fonts/AmaticSC-Bold.ttf' },
  },
};

export const DEFAULT_TEXT_COLOR = '#282828';

/** Kuratierte Palette: Silben-Blau/-Rot, Fitzgerald-nahe Farben, Grundfarben. */
export const TEXT_COLOR_PALETTE = [
  '#282828', '#6b7280', '#2563eb', '#dc2626', '#16a34a', '#ea580c',
  '#ca8a04', '#db2777', '#7c3aed', '#0891b2', '#92400e', '#eab308',
];

export const DEFAULT_TEXT_STYLE: TextStyle = {
  fontSize: 14,
  fontFamily: 'standard',
  bold: false,
  align: 'center',
  border: true,
  color: DEFAULT_TEXT_COLOR,
};

/** Ein Assignment zählt als Textfeld, wenn type 'text' gesetzt ist. */
export function isTextAssignment(a?: { type?: string }): boolean {
  return a?.type === 'text';
}
